import React from 'react'
import AuthViews from 'views/auth-views'

export const AuthLayout = (props) => {
  return (
    <div className="auth-container app-auth-container pp-dark-bg">
      {props.children ? props.children :  <AuthViews />}
    </div>
  )
}


export default AuthLayout
